const NODE_ENV = process.env.NODE_ENV;

let apiUrl, csrfMethod, loadQuestionUrl, loadQuestionMethod, checkDateUrl, checkDateUrlMethod, checkClickUrl, checkClickUrlMethod, checkStoreUrl, checkStoreUrlMethod;

switch (NODE_ENV) {
  case 'production':
    apiUrl = 'https://event.udn.com/actnow/php/Api/';
    csrfMethod = 'POST';
    loadQuestionUrl = 'api/' + 'data.json';
    loadQuestionMethod = 'GET';
    checkDateUrl = apiUrl + 'check_date.php';
    checkDateUrlMethod = 'POST';
    checkClickUrl = apiUrl + 'click.php';
    checkClickUrlMethod = 'POST';
    checkStoreUrl = apiUrl + 'store.php';
    checkStoreUrlMethod = 'POST';
    // console.log(loadQuestionUrl);
    console.log('production online');
    break;
    case 'dc':
      apiUrl = 'https://lab7-event.udn.com/actnow/php/Api/';
      csrfMethod = 'POST';
      loadQuestionUrl = 'api/' + 'data.json';
      loadQuestionMethod = 'GET';
      checkDateUrl = apiUrl + 'check_date.php';
      checkDateUrlMethod = 'POST';
      checkClickUrl = apiUrl + 'click.php';
      checkClickUrlMethod = 'POST';
      checkStoreUrl = apiUrl + 'store.php';
      checkStoreUrlMethod = 'POST';
      console.log('development dc');
      break;
  default:
    apiUrl = 'http://localhost:1234/api/';
    csrfMethod = 'GET';
    loadQuestionUrl = apiUrl + 'data.json';
    loadQuestionMethod = 'GET';
    checkDateUrl = apiUrl + 'check_date1.json';
    checkDateUrlMethod = 'GET';
    checkClickUrl = apiUrl + 'click1.json';
    checkClickUrlMethod = 'GET';
    checkStoreUrl = apiUrl + 'store1.json';
    checkStoreUrlMethod = 'GET';
    console.log('development localhost');
}

export {
  NODE_ENV,
  apiUrl,
  csrfMethod,
  loadQuestionUrl,
  loadQuestionMethod,
  checkDateUrl,
  checkDateUrlMethod,
  checkClickUrl,
  checkClickUrlMethod,
  checkStoreUrl,
  checkStoreUrlMethod
};